var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSummarize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_529_9854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20254 3.56931C10.3003 3.56931 11.1903 2.67936 11.1903 1.58154H12.1077C12.1077 2.67936 12.9977 3.56931 14.0955 3.56931V4.48674C12.9977 4.48674 12.1077 5.37669 12.1077 6.47451H11.1903C11.1903 5.37669 10.3003 4.48674 9.20254 4.48674V3.56931ZM2.47471 4.63965C2.47471 3.96407 3.02237 3.41641 3.69795 3.41641H7.97929V2.19316H3.69795C2.34679 2.19316 1.25146 3.28849 1.25146 4.63965V10.7559C1.25146 12.107 2.34679 13.2023 3.69795 13.2023H11.0374C12.3885 13.2023 13.4839 12.107 13.4839 10.7559V7.69775H12.2606V10.7559C12.2606 11.4315 11.713 11.9791 11.0374 11.9791H3.69795C3.02237 11.9791 2.47471 11.4315 2.47471 10.7559V4.63965Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_9854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6789,
    height: 14.6789,
    fill: "white",
    transform: "translate(0.0275879 0.357666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSummarize);
export default __webpack_public_path__ + "static/media/add-summarize.c68bd0ba342bf223b474ec6dfd9d6e05.svg";
export { ForwardRef as ReactComponent };